import { FreeText } from 'common/components/FreeText/FreeText';
import Spinner from 'components/UI/Spinner';
import ConceptPageHeader from 'conceptPage/components/ConceptPageHeader/ConceptPageHeader';
import { ProductContext } from 'product';
import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useParams } from 'react-router';
import { sanityImageBuilder } from 'utilities/sanityClient';
import { DynamicPageBuilder } from '../../pagebuilder/DynamicPageBuilder';
import { fetchSanityConceptPage } from '../actions';
import './DynamicConceptPage.scss';
function DynamicConceptPage() {
    const location = useLocation();
    const dispatch = useDispatch();
    const { conceptPageSlug } = useParams();
    const [fetchingStatus, setFetchingStatus] = useState('LOADING');
    const [conceptPageData, setConceptPageData] = useState();
    const [error, setError] = useState();
    const regionId = useSelector(({ region }) => region.id);
    const isMobile = useSelector(({ ui }) => ui.isMobile);
    const { bannerStrip1, bannerStrip2 } = conceptPageData || {};
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [conceptPageSlug]);
    useEffect(() => {
        let isSubscribed = true;
        setFetchingStatus('LOADING');
        setConceptPageData(undefined);
        fetchSanityConceptPage(conceptPageSlug.trim(), regionId)
            .then((res) => {
            if (isSubscribed) {
                setFetchingStatus('SUCCESS');
                setConceptPageData(res);
            }
        })
            .catch((e) => {
            if (isSubscribed) {
                setFetchingStatus('ERROR');
                setError(JSON.stringify(e, null, 2));
            }
        });
        return () => {
            isSubscribed = false;
        };
    }, [conceptPageSlug]);
    useEffect(() => {
        dispatch({
            type: 'SET_BANNER_STRIPS',
            payload: { page: location.pathname, bannerStrip1, bannerStrip2 },
        });
        return () => {
            dispatch({ type: 'SET_BANNER_STRIPS', payload: { page: location.pathname } });
        };
    }, [bannerStrip1, bannerStrip2, location.pathname, dispatch]);
    const mainImageUrl = useMemo(function getMainImageUrl() {
        if (!(conceptPageData === null || conceptPageData === void 0 ? void 0 : conceptPageData.mainImage))
            return undefined;
        const headerHeightInPx = isMobile ? 80 : 75;
        return sanityImageBuilder
            .image(conceptPageData.mainImage)
            .fit('crop')
            .height(window.innerHeight - headerHeightInPx)
            .width(Math.ceil(window.innerWidth * 0.9))
            .dpr(window.devicePixelRatio)
            .auto('format')
            .url();
    }, [conceptPageData === null || conceptPageData === void 0 ? void 0 : conceptPageData.mainImage, isMobile]);
    if (fetchingStatus == 'LOADING')
        return React.createElement(Spinner, null);
    if (fetchingStatus == 'ERROR')
        return React.createElement("pre", null, error);
    // TODO: Make better 404 page
    if (conceptPageData == null)
        return React.createElement("h1", null, "Her var det ingenting");
    return (React.createElement(ProductContext.Provider, { value: {
            context: `ConceptPage_${conceptPageSlug.trim()}`,
        } },
        React.createElement("main", { className: "dynamic-concept-page" },
            mainImageUrl && (React.createElement(ConceptPageHeader, { heading: conceptPageData.title, headerImageSrc: mainImageUrl, featuredProductIds: conceptPageData.featuredProductIds })),
            React.createElement("section", { className: "dynamic-concept-page__content" },
                conceptPageData.body && React.createElement(FreeText, { body: conceptPageData.body }),
                conceptPageData.elements && (React.createElement(DynamicPageBuilder, { elements: conceptPageData.elements }))))));
}
export default DynamicConceptPage;
